import createVueComponent from '../createVueComponent';
var LineChart = createVueComponent('LineChartIcon', [['path', {
  d: 'M3 3v18h18'
}], ['path', {
  d: 'm19 9-5 5-4-4-3 3'
}]]);
export default LineChart;